import React from 'react'

const CriticalError = ({ brand }) => (
  <section className="ob-error">
    <h1 className="zb-heading2">Sorry, something went wrong</h1>
    <div className="ob-column-container">
      <div className="zb-card ob-card">
        Please close this page and try again in your banking app. If you keep
        seeing this message{' '}
        <a
          href={brand.getIn(['links', 'contactLink'])}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="More information about how to get in touch with our support team, an external link that will open in a new tab"
        >
          get in touch
        </a>
        .
      </div>
    </div>
  </section>
)

export default CriticalError
